var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video",attrs:{"src":_vm.video_url,"controls":"controls"}},[_vm._v(" 您的浏览器不支持 video 标签。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }